import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  Button,
  DataTable,
  DataTableRow,
  Divider,
  Expander,
  ExpanderContent,
  ExpanderHeader,
  Row,
  H5,
} from '@fs/zion-ui'
import { Link } from '@fs/zion-router'
import { getFrontendBaseUrl } from '../../../../util/UrlUtil'

export default function OdmRecordFamilies({ families, collection }) {
  const { t } = useTranslation()
  const [open, setOpen] = useState(true)
  const [familyIds, setFamilyIds] = useState([])
  const [familyMembers, setFamilyMembers] = useState({})
  const [selectedFamily, setSelectedFamily] = useState(families?.[0]?.id)

  useEffect(() => {
    const ids = []
    const members = []
    families?.forEach((family) => {
      ids.push(family.id)
      members[family.id] = family.members
    })
    setFamilyIds(ids)
    setFamilyMembers(members)
    setSelectedFamily(ids[0])
  }, [families])

  return (
    <>
      <Divider marginY="nano" />
      <Expander open={open} setOpen={setOpen}>
        <ExpanderHeader>
          <H5>{t('odm.family', 'Family')}</H5>
        </ExpanderHeader>
        <ExpanderContent>
          <Row>
            {familyIds &&
              familyIds.map((id) => {
                return (
                  <Button
                    key={id}
                    emphasis={id === selectedFamily ? 'high' : 'medium'}
                    onClick={() => setSelectedFamily(id)}
                  >
                    {id}
                  </Button>
                )
              })}
          </Row>
          <Divider marginY="nano" />
          {familyMembers?.[selectedFamily] && (
            <DataTable
              columns={[
                { label: t('odm.family.position', 'Position'), size: 'xs' },
                { label: t('odm.family.seq', 'Seq'), size: 'xs' },
                { label: t('sex', 'Sex'), size: 'xs' },
                { label: t('givenName', 'Given Name'), size: 'lg' },
                { label: t('surname', 'Surname'), size: 'lg' },
                { label: t('odv.rfn', 'RFN'), size: 'xs' },
                { label: t('odm.family.fosFamNumber', 'FOS Fam #'), size: 'xs' },
                { label: t('odm.family.fosPosition', 'FOS POS'), size: 'xs' },
              ]}
            >
              {familyMembers[selectedFamily].map((member) => {
                return (
                  <DataTableRow
                    key={member.rfn}
                    column1={member.position}
                    column2={member.sequence}
                    column3={member.gender}
                    column4={member.givenName}
                    column5={member.surName}
                    column6={
                      <Link
                        to={`${getFrontendBaseUrl()}/search/odv?search=odmRecords&rfn=${
                          member.rfn
                        }&collection=${collection}`}
                        target="_blank"
                        noScrollTop
                      >
                        {member.rfn}
                      </Link>
                    }
                    column7={member['6']}
                    column8={member['7']}
                  />
                )
              })}
            </DataTable>
          )}
          {!familyIds || (familyIds.length <= 0 && <p>{t('odm.noFamilies', 'No Families')}</p>)}
          <Divider marginY="nano" />
        </ExpanderContent>
      </Expander>
    </>
  )
}
